export default __webpack_public_path__ + "static/media/rename.183cd96a.svg";